import { Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef, Output, EventEmitter, OnChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { bind, FormHelpers } from '@asamco/utils';
import Swal from 'sweetalert2';
import { SchedulerExpiration, SchedulerPeriodicity } from '../../../enums/scheduler-types.enum';
import { LinkSchedulerCreateObject } from '../../../interfaces/link-scheduler-create-object.interface';
import { LinkSchedulerInformation } from '../../../interfaces/link-scheduler-information.interface';
import { DailyRecurrenceGroup, EndRecurrence, endRecurrenceTypeEnum, HourlyRecurrenceGroup, LinkSchedulerObject, MonthlyRecurrenceGroup, recurrencePeriodicityEnum, RecurringGroup, WeeklyRecurrenceGroup } from '../../../interfaces/link-scheduler-object.interface';
import { Link } from '../../../interfaces/link.interface';
import { LinkInformation } from '../../../interfaces/linkinformation.interface';
import { MarketPlaceItem } from '../../../interfaces/market-place-item.interface';
import { JobService } from '../../../services/job.service';
import { SchedulerService } from '../../../services/scheduler.service';
import { AsValidatorDirective } from '../../../../../../../base/src/lib/as-validator/as-validator.directive';
import { DxDateBoxModule, DxSwitchModule, DxSelectBoxModule, DxNumberBoxModule, DxButtonGroupModule, DxRadioGroupModule } from 'devextreme-angular';
import { NgIf } from '@angular/common';

@Component({
    selector: 'al-link-edit-scheduler-form',
    templateUrl: './link-edit-scheduler-form.component.html',
    styleUrls: ['./link-edit-scheduler-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        DxDateBoxModule,
        AsValidatorDirective,
        DxSwitchModule,
        DxSelectBoxModule,
        DxNumberBoxModule,
        DxButtonGroupModule,
        DxRadioGroupModule,
    ],
})
export class LinkEditSchedulerFormComponent implements OnInit, OnChanges {
	@Input()
	linkSchedulerInformation: LinkSchedulerInformation

	@Input()
	hourlySchedulerAllowanceHours: number | null;

	@Input()
	disabled: boolean = false;

	/**Arrays used for displaying periodicity and expiration type */
	periodicityKeys: any[];
	expirationDataSource: any[];

	/**Scheduler requires a datetime for initial date */
	public now: Date = new Date(Date.now());

	/**Boolean used for visibility of modal */
	public visible: boolean = false;
	formGroup: FormGroup;
	/**Check if form is initialized */
	formInitialized: boolean = false;
	public selectedPeriodicityValue: number | null = null;

	periodicityString: string = 'Repeat every (x) time';
	/**Boolean to check if the modal is only used for viewing (and not for adding a new schedule) */
	viewOnly: boolean = false;
	/**Title of the modal */
	public title: string;

	/**Tracking which item is currently selected */
	currentItem: any;

	public selectedEndType: number = 0;

	timezone: string;

	public weekdays = [
		{
			id: 'MO',
			text: 'Mon'
		},
		{
			id: 'TU',
			text: 'Tue'
		},
		{
			id: 'WE',
			text: 'Wed'
		},
		{
			id: 'TH',
			text: 'Thu'
		},
		{
			id: 'FR',
			text: 'Fri'
		},
		{
			id: 'SA',
			text: 'Sat'
		},
		{
			id: 'SU',
			text: 'Sun'
		},
	]

	public endtypeList = [
		{
		  id: endRecurrenceTypeEnum.NEVER,
		  description: 'Never'
		},
		{
		  id: endRecurrenceTypeEnum.ONDATE,
		  description: 'On'
		},
		{
		  id: endRecurrenceTypeEnum.ONCOUNT,
		  description: 'After'
		}
	  ]

	public periodicityList = [

	  ]

	public selectedWeekdays: Array<any> = [];
	public selectedEndDateItems: Array<any>;

	constructor(private scheduleService: SchedulerService, private cdr: ChangeDetectorRef, private scheduledJobService: SchedulerService, private fb: FormBuilder) {
		this.assignPrefabSelect();
		this.assignPrefabExpirationSelect();
	}

	ngOnInit(): void {
		this.setupLinkAllowedPeriodicity();
		this.buildFormGroup(this.linkSchedulerInformation)
		this.formInitialized = true;
		//this.showModal({startDate: new Date(Date.now())});
		//this.toggleRecurrenceValidator();
	}

	ngOnChanges(): void {
		this.applyFormDisabledState();
	}


	close() {
		this.visible = false;
	}

	getSchedulerConfiguration() {
		return this.formGroup.getRawValue();
	}

	setupLinkAllowedPeriodicity() {
		if(this.hourlySchedulerAllowanceHours) {
			this.periodicityList = [
				{
					id: recurrencePeriodicityEnum.HOURLY,
					description: 'Hourly'
				  },
				  {
					id: recurrencePeriodicityEnum.DAILY,
					description: 'Daily'
				  },
				  {
					id: recurrencePeriodicityEnum.WEEKLY,
					description: 'Weekly'
				  },
				  {
					id: recurrencePeriodicityEnum.MONTHLY,
					description: 'Monthly'
				  },
				  // {
				  //   id: 4,
				  //   description: 'Yearly'
				  // }
			]
		}
		else
		{
			this.periodicityList = [
				  {
					id: recurrencePeriodicityEnum.DAILY,
					description: 'Daily'
				  },
				  {
					id: recurrencePeriodicityEnum.WEEKLY,
					description: 'Weekly'
				  },
				  {
					id: recurrencePeriodicityEnum.MONTHLY,
					description: 'Monthly'
				  },
				  // {
				  //   id: 4,
				  //   description: 'Yearly'
				  // }
			]
		}
	}


	public save() {
		console.log(this.formGroup.getRawValue())

		const linkSchedulerDto = {} as LinkSchedulerCreateObject;
		linkSchedulerDto.isSchedulerEnabled = this.formGroup.get('isRecurring')?.value
		linkSchedulerDto.recurrenceRules = this.getICALRecurrenceRule(),

		//Depending on the serialization that's happening underneath DevExtreme's Dx Date Box this might be different, so we streamline it to ALWAYS be UTC
		linkSchedulerDto.startDate = this.formGroup.get('startDate')?.value;

		if (FormHelpers.validateForm(this.formGroup)) {
			linkSchedulerDto.linkId = this.linkSchedulerInformation.linkId;


			// result.startDate = new Date(result.startDate);

			this.scheduleService.addScheduleInfo(linkSchedulerDto).subscribe(e => {
				this.close();
				Swal.fire({
					title: 'Succesfully added schedule',
					timer: 3000,
					icon: 'success',
				});

			});
			return linkSchedulerDto;
		}

		return null;
	}


	@bind
	dateValidator(c: FormControl) {
		// Not sure if c will come in as a date or if we have to convert is somehow

		let asiaTime = new Date().toLocaleString("en-US", { timeZone: this.timezone });
		let today = new Date(asiaTime);
		if (c.value > today) {
			return null;
		} else {
			return { dateValidator: { valid: false } };
		}
	}

	onRadioGroupValueChanged($event: any) {
		if (this.disabled) {
			return;
		}

		this.applyEndRecurrenceEnabledState($event.value);
	  }

	private applyEndRecurrenceEnabledState(value: endRecurrenceTypeEnum) {
		if (value == endRecurrenceTypeEnum.NEVER) {
		  this.formGroup.controls['recurringGroup'].get('endRecurrence')?.get('endRecurrenceDate')?.disable();
		  this.formGroup.controls['recurringGroup'].get('endRecurrence')?.get('endRecurrenceCount')?.disable();
		}
		else if (
		  value == endRecurrenceTypeEnum.ONDATE
		) {
		  this.formGroup.controls['recurringGroup'].get('endRecurrence')?.get('endRecurrenceCount')?.disable();
		  this.formGroup.controls['recurringGroup'].get('endRecurrence')?.get('endRecurrenceDate')?.enable();
		}
		else if (value == endRecurrenceTypeEnum.ONCOUNT) {
		  this.formGroup.controls['recurringGroup'].get('endRecurrence')?.get('endRecurrenceDate')?.disable();
		  this.formGroup.controls['recurringGroup'].get('endRecurrence')?.get('endRecurrenceCount')?.enable();
		}
	}

	buildFormGroup(linkSchedulerInformation: LinkSchedulerInformation) {
		if (linkSchedulerInformation.recurrenceRule) {
			//Translate the recurrence rule to the values for the formgroup
			const linkSchedulerObject = this.getLinkSchedulerObjectFromRecurrenceRule(linkSchedulerInformation);
			if (linkSchedulerObject) {
				let recurrenceTypeValue: number = linkSchedulerObject.recurringGroup.endRecurrence.endRecurrenceType;
				let endRecurrenceDateValue: Date = linkSchedulerObject.recurringGroup?.endRecurrence?.endRecurrenceDate ? linkSchedulerObject.recurringGroup.endRecurrence.endRecurrenceDate : new Date(Date.now());
				let endRecurrenceCountValue: number = linkSchedulerObject.recurringGroup?.endRecurrence?.endRecurrenceCount ? linkSchedulerObject.recurringGroup.endRecurrence.endRecurrenceCount : 1;
				let hourlyRecurrenceEveryXHoursValue: number = linkSchedulerObject.recurringGroup?.hourlyRecurrenceGroup?.hourlyRecurrenceEveryXHours ? linkSchedulerObject.recurringGroup.hourlyRecurrenceGroup.hourlyRecurrenceEveryXHours : this.hourlySchedulerAllowanceHours;
				let dailyRecurrenceEveryXDaysValue: number = linkSchedulerObject.recurringGroup?.dailyRecurrenceGroup?.dailyRecurrenceEveryXDays ? linkSchedulerObject.recurringGroup.dailyRecurrenceGroup.dailyRecurrenceEveryXDays : 1;
				let weeklyRecurrenceEveryXWeeksValue: number = linkSchedulerObject.recurringGroup.weeklyRecurrenceGroup?.weeklyRecurrenceRepeatOnDays ? linkSchedulerObject.recurringGroup.weeklyRecurrenceGroup.weeklyRecurrenceRepeatOnDays : 1
				let monthlyRecurrenceEveryXMonthsValue: number = linkSchedulerObject.recurringGroup.monthlyRecurrenceGroup?.monthlyRecurrenceEveryXMonths ? linkSchedulerObject.recurringGroup.monthlyRecurrenceGroup.monthlyRecurrenceEveryXMonths : 1;
				let monthlyRecurrenceRepeatOnDayValue: number = linkSchedulerObject.recurringGroup.monthlyRecurrenceGroup?.monthlyRecurrenceRepeatOnDay ? linkSchedulerObject.recurringGroup.monthlyRecurrenceGroup.monthlyRecurrenceRepeatOnDay : 1

				this.formGroup = this.fb.group({
					startDate: new FormControl(linkSchedulerObject.startDate), //The start date of the scheduler
					isRecurring: new FormControl(linkSchedulerObject.isRecurring), //Dx switch to check whether this is recurring
					recurringGroup: this.fb.group({
						recurrencePeriodicity: new FormControl(linkSchedulerObject.recurringGroup.recurrencePeriodicity), //the periodicity (hourly/daily/weekly/monthly/yearly), default on hourly
						endRecurrence: this.fb.group({
							endRecurrenceType: new FormControl(recurrenceTypeValue), //Radio button select boxes (Never/On/After)
							endRecurrenceDate: new FormControl({ value: endRecurrenceDateValue, disabled: true }), //End date (On, dx-date-box)
							endRecurrenceCount: new FormControl({ value: endRecurrenceCountValue, disabled: true }) //End occurence count (dx-number-box)
						}),
						hourlyRecurrenceGroup: this.fb.group({
							hourlyRecurrenceEveryXHours: new FormControl(hourlyRecurrenceEveryXHoursValue), //Repeat every 'x' hours
						}),
						dailyRecurrenceGroup: this.fb.group({
							dailyRecurrenceEveryXDays: new FormControl(dailyRecurrenceEveryXDaysValue) //Repeat every 'X' days
						}),
						weeklyRecurrenceGroup: this.fb.group({
							weeklyRecurrenceyEveryXWeeks: new FormControl(weeklyRecurrenceEveryXWeeksValue), //Repeat every 'X' weeks
							weeklyRecurrenceRepeatOnDays: new FormControl(), //Repeat every time on given day (mon/sunday selection)
						}),
						monthlyRecurrenceGroup: this.fb.group({
							monthlyRecurrenceEveryXMonths: new FormControl(monthlyRecurrenceEveryXMonthsValue), //Repeat every 'X' months
							monthlyRecurrenceRepeatOnDay: new FormControl(monthlyRecurrenceRepeatOnDayValue) //Repeat on a specific day (for example, 24th every month)
						})
					}),
				})

				this.selectedPeriodicityValue = this.formGroup.get('recurringGroup')?.get('recurrencePeriodicity')?.value;

				if (linkSchedulerObject.recurringGroup.endRecurrence.endRecurrenceType) {
					if (linkSchedulerObject.recurringGroup.endRecurrence.endRecurrenceType == endRecurrenceTypeEnum.ONCOUNT) {
						this.formGroup.get('recurringGroup')?.get('endRecurrence')?.get('endRecurrenceCount')?.enable();
					}
					else if (linkSchedulerObject.recurringGroup.endRecurrence.endRecurrenceType == endRecurrenceTypeEnum.ONDATE) {
						this.formGroup.get('recurringGroup')?.get('endRecurrence')?.get('endRecurrenceDate')?.enable();
					}
				}
			}
		}
		else {
			this.formGroup = this.fb.group({
				startDate: new FormControl(), //The start date of the scheduler
				isRecurring: new FormControl(false), //Dx switch to check whether this is recurring
				recurringGroup: this.fb.group({
					recurrencePeriodicity: new FormControl(recurrencePeriodicityEnum.DAILY), //the periodicity (hourly/daily/weekly/monthly/yearly), default on hourly
					endRecurrence: this.fb.group({
						endRecurrenceType: new FormControl(endRecurrenceTypeEnum.NEVER), //Radio button select boxes (Never/On/After)
						endRecurrenceDate: new FormControl({ value: new Date(Date.now()), disabled: true }), //End date (On, dx-date-box)
						endRecurrenceCount: new FormControl({ value: 1, disabled: true }) //End occurence count (dx-number-box)
					}),
					hourlyRecurrenceGroup: this.fb.group({
						hourlyRecurrenceEveryXHours: new FormControl(this.hourlySchedulerAllowanceHours), //Repeat every 'x' hours
					}),
					dailyRecurrenceGroup: this.fb.group({
						dailyRecurrenceEveryXDays: new FormControl(1) //Repeat every 'X' days
					}),
					weeklyRecurrenceGroup: this.fb.group({
						weeklyRecurrenceyEveryXWeeks: new FormControl(1), //Repeat every 'X' weeks
						weeklyRecurrenceRepeatOnDays: new FormControl([]), //Repeat every time on given day (mon/sunday selection)
					}),
					monthlyRecurrenceGroup: this.fb.group({
						monthlyRecurrenceEveryXMonths: new FormControl(1), //Repeat every 'X' months
						monthlyRecurrenceRepeatOnDay: new FormControl([]) //Repeat on a specific day (for example, 24th every month)
					})
				}),
			})

			this.selectedPeriodicityValue = this.formGroup.get('recurringGroup')?.get('recurrencePeriodicity')?.value;
		}

		this.applyFormDisabledState();

	}

	private applyFormDisabledState() {
		if (!this.formGroup) {
			return;
		}

		if (this.disabled) {
			this.formGroup.disable({ emitEvent: false });
		}
		else {
			this.formGroup.enable({ emitEvent: false });
			this.applyEndRecurrenceEnabledState(this.formGroup.controls['recurringGroup'].get('endRecurrence')?.get('endRecurrenceType')?.value);
		}
	}

	initFormGroup() {
		this.formGroup = new FormGroup({
			startDate: new FormControl(new Date(), [Validators.required, this.dateValidator]),
			recurrence: new FormControl(false),
			periodicity: new FormControl(1, Validators.required),
			interval: new FormControl({ value: 1, disabled: false }, Validators.required),
			expirationType: new FormControl(1, Validators.required),
			occurrences: new FormControl(1, Validators.required),
			expirationDate: new FormControl(new Date(), Validators.required),
		});

		this.formInitialized = true;
	}

	changePeriodicityString(e) {
		document.getElementById('periodString').innerHTML = 'Repeat every (x) ' + this.periodicityKeys[e.value - 1].period;
	}

	public getICALRecurrenceRule() {

		const formValues: LinkSchedulerObject = this.formGroup.value;
		//Check if recurrence is enabled
		if (formValues.isRecurring) {
			let recurrenceRule = 'FREQ=';
			let periodicity = formValues.recurringGroup.recurrencePeriodicity;
			//Checking which periodicity is selected
			if (periodicity < 0) {
				throw ('Periodicity not selected')
			}

			if (periodicity == recurrencePeriodicityEnum.HOURLY) {
				recurrenceRule += 'HOURLY;';
				let interval: number = formValues.recurringGroup.hourlyRecurrenceGroup.hourlyRecurrenceEveryXHours;
				if (interval > 1) {
					recurrenceRule += 'INTERVAL=' + interval + ';';
				}
			}
			else if (periodicity == recurrencePeriodicityEnum.DAILY) {
				recurrenceRule += 'DAILY;';
				let interval: number = formValues.recurringGroup.dailyRecurrenceGroup.dailyRecurrenceEveryXDays;
				if (interval > 1) {
					recurrenceRule += 'INTERVAL=' + interval + ';';
				}
			}
			else if (periodicity == recurrencePeriodicityEnum.WEEKLY) {
				recurrenceRule += 'WEEKLY;';
				let interval: number = formValues.recurringGroup.weeklyRecurrenceGroup.weeklyRecurrenceyEveryXWeeks;
				if (interval > 1) {
					recurrenceRule += 'INTERVAL=' + interval + ';';
				}

				// let daysSelected: any[] = formValues.recurringGroup.weeklyRecurrenceGroup.weeklyRecurrenceRepeatOnDays;
				if (this.selectedWeekdays.length > 0) {

					recurrenceRule += 'BYDAY=' + this.selectedWeekdays.map(item => item.id).join(',') + ';';

				}
			}
			else if (periodicity == recurrencePeriodicityEnum.MONTHLY) {
				recurrenceRule += 'MONTHLY;';
				let interval: number = formValues.recurringGroup.monthlyRecurrenceGroup.monthlyRecurrenceEveryXMonths;
				if (interval > 1) {
					recurrenceRule += 'INTERVAL=' + interval + ';';
				}

				let specifiedDay = formValues.recurringGroup.monthlyRecurrenceGroup.monthlyRecurrenceRepeatOnDay;
				recurrenceRule += 'BYMONTHDAY=' + specifiedDay + ';';
			}

			if (formValues.recurringGroup.endRecurrence.endRecurrenceType === endRecurrenceTypeEnum.ONDATE) {
				recurrenceRule += 'UNTIL=' + this.formatDateTime(formValues.recurringGroup.endRecurrence.endRecurrenceDate);
			}
			else if (formValues.recurringGroup.endRecurrence.endRecurrenceType === endRecurrenceTypeEnum.ONCOUNT) {
				recurrenceRule += 'COUNT=' + formValues.recurringGroup.endRecurrence.endRecurrenceCount;
			}




			return recurrenceRule.replace(/\;$/, ''); //trim last colon if it exists
		}

		return '';
	}

	getEnumValue(enumObj: any, enumKey: string): number | undefined {
		for (const key in enumObj) {
			if (key === enumKey) {
				return enumObj[key];
			}
		}
		return undefined;
	}


	getLinkSchedulerObjectFromRecurrenceRule(linkSchedulerInformation: LinkSchedulerInformation): LinkSchedulerObject | null {

		let linkSchedulerObject: LinkSchedulerObject | null = null;
		if (linkSchedulerInformation.startDate) {
			linkSchedulerObject = {} as LinkSchedulerObject;
			linkSchedulerObject.startDate = linkSchedulerInformation.startDate;
		}

		if (!linkSchedulerObject) {
			return null;
		}

		if (linkSchedulerInformation.recurrenceRule) {

			linkSchedulerObject.isRecurring = true;
			linkSchedulerObject.recurringGroup = {} as RecurringGroup;

			//find periodicity
			const periodicity: string | null = this.getValueBetweenStrings(linkSchedulerInformation.recurrenceRule, 'FREQ=', ';');
			let periodicityValue: number = 0;

			if (periodicity) {
				const periodicityNumericValue: number | undefined = this.getEnumValue(recurrencePeriodicityEnum, periodicity);
				if (periodicityNumericValue) {
					periodicityValue = periodicityNumericValue;
					linkSchedulerObject.recurringGroup.recurrencePeriodicity = periodicityNumericValue;
				}
			}
			else //We always need a periodicity
			{
				return null;
			}

			//find interval
			const interval: string | null = this.getValueBetweenStrings(linkSchedulerInformation.recurrenceRule, 'INTERVAL=', ';');
			const intervalNumber: number = Number(interval);
			switch (periodicityValue) {
				case recurrencePeriodicityEnum.HOURLY:
					linkSchedulerObject.recurringGroup.hourlyRecurrenceGroup = {} as HourlyRecurrenceGroup;
					linkSchedulerObject.recurringGroup.hourlyRecurrenceGroup.hourlyRecurrenceEveryXHours = interval ? intervalNumber : 1;
					break;
				case recurrencePeriodicityEnum.DAILY:
					linkSchedulerObject.recurringGroup.dailyRecurrenceGroup = {} as DailyRecurrenceGroup;
					linkSchedulerObject.recurringGroup.dailyRecurrenceGroup.dailyRecurrenceEveryXDays = interval ? intervalNumber : 1;
					break;
				case recurrencePeriodicityEnum.WEEKLY:
					linkSchedulerObject.recurringGroup.weeklyRecurrenceGroup = {} as WeeklyRecurrenceGroup;
					linkSchedulerObject.recurringGroup.weeklyRecurrenceGroup.weeklyRecurrenceyEveryXWeeks = interval ? intervalNumber : 1;
					break;
				case recurrencePeriodicityEnum.MONTHLY:
					linkSchedulerObject.recurringGroup.monthlyRecurrenceGroup = {} as MonthlyRecurrenceGroup;
					linkSchedulerObject.recurringGroup.monthlyRecurrenceGroup.monthlyRecurrenceEveryXMonths = interval ? intervalNumber : 1;
					break;
			}

			//find byday
			const byDay: string | null = this.getValueBetweenStrings(linkSchedulerInformation.recurrenceRule, 'BYDAY=', ';')
			if (byDay) {
				const strList: string[] = byDay.split(',');
				this.selectedWeekdays = this.weekdays.filter(item => {
					return strList.some(filterItem => item.id == filterItem)
				})
			}

			//find by month day
			const byMonthDay: string | null = this.getValueBetweenStrings(linkSchedulerInformation.recurrenceRule, 'BYMONTHDAY=', ';')
			if (byMonthDay) {
				const byMonthDayNumber: number = Number(byMonthDay);
				if (byMonthDayNumber) {
					if (!linkSchedulerObject.recurringGroup.monthlyRecurrenceGroup) {
						linkSchedulerObject.recurringGroup.monthlyRecurrenceGroup = {} as MonthlyRecurrenceGroup;
					}
					linkSchedulerObject.recurringGroup.monthlyRecurrenceGroup.monthlyRecurrenceRepeatOnDay = byMonthDayNumber;

				}

			}

			//until date

			const untilDate: string | null = this.getValueBetweenStrings(linkSchedulerInformation.recurrenceRule, 'UNTIL=', ';');
			if (untilDate) {
				linkSchedulerObject.recurringGroup.endRecurrence = {} as EndRecurrence;
				const parsedDate: Date | null = this.parseDateTime(untilDate);
				if (parsedDate) {
					linkSchedulerObject.recurringGroup.endRecurrence.endRecurrenceDate = parsedDate;
				}

				linkSchedulerObject.recurringGroup.endRecurrence.endRecurrenceType = endRecurrenceTypeEnum.ONDATE;
			}

			//until count
			const count: string | null = this.getValueBetweenStrings(linkSchedulerInformation.recurrenceRule, 'COUNT=', ';')
			if (count) {
				const countAsNumber: number = Number(count);
				if (!linkSchedulerObject.recurringGroup.endRecurrence) {
					linkSchedulerObject.recurringGroup.endRecurrence = {} as EndRecurrence;
					linkSchedulerObject.recurringGroup.endRecurrence.endRecurrenceCount = countAsNumber;
				}
				linkSchedulerObject.recurringGroup.endRecurrence.endRecurrenceType = endRecurrenceTypeEnum.ONCOUNT;
			}

			if (!count && !untilDate) {
				if (!linkSchedulerObject.recurringGroup.endRecurrence) {
					linkSchedulerObject.recurringGroup.endRecurrence = {} as EndRecurrence;
				}
				linkSchedulerObject.recurringGroup.endRecurrence.endRecurrenceType = endRecurrenceTypeEnum.NEVER;
			}

			return linkSchedulerObject;
		}

		return null;
	}

	assignPrefabSelect() {
		this.periodicityKeys = [
			{ ID: SchedulerPeriodicity.hourly, text: 'Hourly', period: 'hour(s)' },
			{ ID: SchedulerPeriodicity.daily, text: 'Daily', period: 'day(s)' },
			{ ID: SchedulerPeriodicity.weekly, text: 'Weekly', period: 'week(s)' },
			{ ID: SchedulerPeriodicity.monthly, text: 'Monthly', period: 'month(s)' },
		];
		this.LimitMaximumAllowedFrequency();
	}

	assignPrefabExpirationSelect() {
		this.expirationDataSource = [
			{ ID: SchedulerExpiration.never, text: 'Never' },
			{ ID: SchedulerExpiration.date, text: 'On a date' },
			{ ID: SchedulerExpiration.occurences, text: 'After an amount of occurrences' },
		];
	}

	LimitMaximumAllowedFrequency() {
		//TODO: Add max frequency based on LinkInfo table
		const allowedFreq = SchedulerPeriodicity.undefined;
		this.periodicityKeys = this.periodicityKeys.filter(t => t.ID > allowedFreq);
	}

	getValueBetweenStrings(input: string, startString: string, endString: string): string | null {
		const regex = new RegExp(`${startString}(.*?)(?=${endString}|$)`);
		const matches = regex.exec(input);
		if (matches && matches.length >= 2) {
			return matches[1];
		}
		return null;
	}

	parseDateTime(dateTimeString: string): Date | null {
		const regex = /^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})$/;
		const match = dateTimeString.match(regex);

		if (match) {
			const [, year, month, day, hour, minute, second] = match;
			const date = new Date();
			date.setUTCFullYear(parseInt(year, 10));
			date.setUTCMonth(parseInt(month, 10) - 1);
			date.setUTCDate(parseInt(day, 10));
			date.setUTCHours(parseInt(hour, 10));
			date.setUTCMinutes(parseInt(minute, 10));
			date.setUTCSeconds(parseInt(second, 10));
			return date;
		}

		return null;
	}

	pad(i: any) {
		return i < 10 ? `0${i}` : `${i}`;
	}


	formatDateTime(date: Date) {
		const year = date.getUTCFullYear();
		const month = this.pad(date.getUTCMonth() + 1);
		const day = this.pad(date.getUTCDate());
		const hour = this.pad(date.getUTCHours());
		const minute = this.pad(date.getUTCMinutes());
		const second = this.pad(date.getUTCSeconds());
		return `${year}${month}${day}T${hour}${minute}${second}Z`;
	}
}
